import { render, staticRenderFns } from "./plus-gift.vue?vue&type=template&id=0ac3f52a&scoped=true&lang=pug&"
import script from "./plus-gift.vue?vue&type=script&lang=js&"
export * from "./plus-gift.vue?vue&type=script&lang=js&"
import style0 from "./plus-gift.vue?vue&type=style&index=0&id=0ac3f52a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3f52a",
  null
  
)

export default component.exports